import React, { FunctionComponent, useEffect } from 'react';
import Map, { Marker } from 'react-map-gl';
import useOutagesMap, {
  DEFAULT_MAP_LAT,
  DEFAULT_MAP_LNG,
} from '../../hooks/useOutagesMap';
import { makeStyles, createStyles } from '@material-ui/core';

export interface StaticMapProps {
  marker?: { lat: number; lng: number };
  center: { lat: number; lng: number };
  onLoad?: () => void;
}

export const MarkerIcon = () => (
  <svg
    width="40px"
    height="40px"
    viewBox="0 0 24.00 24.00"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    transform="rotate(0)matrix(1, 0, 0, 1, 0, 0)"
  >
    <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
    <g
      id="SVGRepo_tracerCarrier"
      strokeLinecap="round"
      strokeLinejoin="round"
    ></g>
    <g id="SVGRepo_iconCarrier">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.7685 23.0866C9.7296 23.1333 9.6866 23.1763 9.6399 23.2152C9.2154 23.5686 8.5849 23.511 8.2315 23.0866C2.74384 16.4959 0 11.6798 0 8.63811C0 3.86741 4.2293 0 9 0C13.7707 0 18 3.86741 18 8.63811C18 11.6798 15.2562 16.4959 9.7685 23.0866zM9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6C7.3431 6 6 7.34315 6 9C6 10.6569 7.3431 12 9 12z"
        fill="#EA4335"
      ></path>
    </g>
  </svg>
);

const useStyles = makeStyles(() =>
  createStyles({
    rootContainer: () => ({
      '& > *:nth-child(1)': {
        height: '100% !important',
        width: '100% !important',
      },
    }),
  }),
);

const StaticMap: FunctionComponent<StaticMapProps> = ({
  center,
  marker,
  onLoad,
}) => {
  const { mapOptions, updateViewPort } = useOutagesMap();
  const initialViewState = {
    longitude: center.lng,
    latitude: center.lat,
    zoom: 9,
  };
  const classes = useStyles();

  useEffect(() => {
    if (center) {
      updateViewPort({
        latitude: center.lat,
        longitude: center.lng,
        zoom: marker ? 14 : 9,
      });
    }
  }, [center, marker]);

  return (
    <div
      style={{ width: '100%', height: '300px' }}
      className={classes.rootContainer}
    >
      <Map
        {...mapOptions}
        initialViewState={initialViewState}
        attributionControl={false}
        interactive={false}
        dragPan={false}
        dragRotate={false}
        scrollZoom={false}
        touchZoomRotate={false}
        doubleClickZoom={false}
        keyboard={false}
        {...(onLoad ? { onLoad: onLoad } : {})}
      >
        {marker && (
          <Marker
            latitude={marker.lat}
            longitude={marker.lng}
            /* offsetLeft={-15}
            offsetTop={-40} */
          >
            <MarkerIcon />
          </Marker>
        )}
      </Map>
    </div>
  );
};

export default StaticMap;
